<template>
  <main>
    <form v-if="!UdyamData?.length" @submit.prevent="setUdyamToBusiness()" class="py-8 justify-center justify-items-center text-center text-black">
      <section class="grid gap-4 min-w-formFullWidth">
        <!-- KYC Animation -->
        <div class="grid w-auto justify-items-center">
          <img src="../assets/udyam-verification.svg" alt="add gst image" width="250" height="250" />
        </div>
        <div class="grid gap-1 text-left">
          <p class="label-text-medium">
            Udyam Verification
          </p>
          <input
            title="UDYAM-**-**-*******"
            type="text"
            name="udyam"
            id="udyam"
            class="input"
            :value="udyam?.toUpperCase()"
            @input="udyam = $event.target.value.toUpperCase().trim()"
            pattern="^UDYAM-[A-Z]{2}-\d{2}-\d{7}$"
            minlength="16"
            maxlength="20"
            placeholder="Enter Udyam Number"
            required
          />
        </div>
      </section>
      <span class="grid pb-10"></span>
      <section class="footer">
        <p @click.prevent="routeBack()" class="text-primaryLight label-text-medium text-center underline cursor-pointer">
          I don’t have a Udyam Number
        </p>
        <custom-button
          variant="primary"
          type="submit"
        >
          <p class="grid text-base">
            Submit
          </p>
        </custom-button>
      </section>
      <!-- Spin Loader -->
      <spin-loader :spinLoading="isSpinLoading"/>
    </form>
    <form @submit.prevent="redirect(selectRadioData)" v-else class="grid gap-4 w-full min-w-formFullWidth">
      <section v-if="UdyamData?.length > 0" class="grid gap-2 pt-4 summary-section-gstin">
        <aside v-for="(data, index) in  UdyamData" :key="index">
          <div class="grid h-auto border py-4 rounded-2xl bg-white">
            <div
              class="flex justify-between items-center px-5 pb-2"
            >
              <div class="gird font-myriad">
                <div class="secondary-heading-text">Udyam {{ index + 1 }}</div>
                <p class="label-text-medium">{{ data.udyamNumber }}</p>
              </div>
              <input
                class="cursor-pointer custom-radio focus:ring-0 focus:outline-none"
                v-model.trim="selectRadioData"
                required
                type="radio"
                :id="data.name + index"
                name="udyam"
                :value="data"
              />
            </div>
            <hr class="pb-2" v-if="data.officialName"/>
            <div class="px-5">
              <div class="font-myriad text-base text-headingColor'">
                <div class="secondary-heading-text">Business Name</div>
                <div class="label-text-medium">{{ data.officialName }}</div>
              </div>
            </div>
          </div>
        </aside>
      </section>
      <span class="grid pb-10"></span>
      <section class="footer">
        <custom-button
          :variant="selectRadioData ? 'primary' : 'disableGray'"
          :disabled="!selectRadioData"
          type="submit"
        >
          <p class="grid text-base">
            Submit
          </p>
        </custom-button>
      </section>
    </form>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import CustomButton from '../components/CustomButton.vue';
import SpinLoader from '../components/spinLoader.vue';

export default {
  name: 'Udyam Verification Add',
  components: {
    CustomButton,
    SpinLoader
  },
  computed: {
    ...mapGetters(['applicationId', 'flagsData']),
  },
  data() {
    return {
      isSpinLoading: undefined,
      udyam: undefined,
      UdyamData: [],
      selectRadioData: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
    },
    setUdyamToBusiness() {
      this.isSpinLoading = true;
      return new Promise((resolve, reject) => {
        const rowData = {
          udyam_reg_no: this.udyam,
        };
        this.$store
          .dispatch('digiTapUdyamToBusiness', {
            rowData,
            applicationId: this.applicationId
          })
          .then((result) => {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_UDYAM_SUBMIT, {
              [this.$mixpanelPayload.RESPONSE]: 'success',
              [this.$mixpanelPayload.KEY_MESSAGE]: this.$route.meta.redirectBackTo,
            });
            resolve(result);
            this.redirect(result);
            this.isSpinLoading = false;
          })
          .catch((err) => {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_UDYAM_SUBMIT, {
              [this.$mixpanelPayload.ERROR_REASON]: `Error msg${err.message} routeBackTo:- ${this.$route.meta.redirectBackTo}`,
            });
            reject(err);
            this.isSpinLoading = false;
          });
      });
    },
    redirect(data) {
      this.$store.commit('UDYAM_DATA_PASS',
        {
          udyamNumber: data?.udyamNumber,
          officialName: data?.officialName
        },
      );
      this.$router.push({
        name: this.$route.meta.redirectBackTo,
      });
    },
    routeBack() {
      this.$router.push({
        name: this.$route.meta.redirectBackTo,
      });
    },
    getMobileUdyamDetails() {
      this.isSpinLoading = true;
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('digiTapMobileUdyamDetails', {
            applicationId: this.applicationId,
          })
          .then((result) => {
            resolve(result);
            if (result) {
            this.UdyamData = result.udyams.map(item => ({
                udyamNumber: item.udyamNumber,
                officialName: item.enterpriseName
              }));
            } else {
              this.UdyamData = [];
            }
            this.isSpinLoading = false;
          })
          .catch((err) => {
            reject(err);
            this.isSpinLoading = false;
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-radio {
  /* Remove default styling */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* Base look */
  border: 1px solid #00517B;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  background-color: transparent;
  outline: none;

  /* Prevent flicker */
  background-clip: padding-box;
  box-sizing: border-box;
  transition:
    border-color 0.15s ease-in-out,
    background-color 0.15s ease-in-out;
}

.custom-radio::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 12px;
  background-color: #00517B;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.15s ease-in-out;
  will-change: transform;
}

.custom-radio:checked {
  border-color: #00517B;
  background-color: #fff; /* Keeps it white when checked */
}

.custom-radio:checked::after {
  transform: translate(-50%, -50%) scale(1);
}

.custom-radio:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 81, 123, 0.2);
}
</style>
